<template>
  <div>
    <v-navigation-drawer permanent left absolute v-if="!nonDesktopMode" height="unset"
                         :floating="true" width="256">

      <v-list
        v-bind:class="{'sports-sidebar-scrollbar':!nonDesktopMode}"
        v-show="selectedSport === 'none'"
      >

        <v-list-item-group color="primary">
          <v-list-item v-if="sportsList.length > 0"
                       @click="selectPopularAsSport"
                       :ripple="false"
          > <!-- removed Android click effect -->
            <v-list-item-avatar
              size="32"
            >
              <v-img :src="(sportsToIconsMapping.defaultIcon)"
                     height="32"
                     width="32"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="sport-is-selected-desktop">
              <v-list-item-title
                v-html="$t(`sports.${sportsList[0].sportIdentifier}`)"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="sportsList[0].liveNow > 0" :class="'total-indication'">
              <v-list-item-action-text v-text="sportsList[0].liveNow"></v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>

          <template v-for="(sport, i) in sportsList" v-if=" sportsList.length >0 && i>0 "
          >
            <v-list-item
              v-bind:class="{'sport-is-selected-desktop':selectedSportData.id === sport.name}"
              :key="i"
              :ripple="false"
              @click="setSelectedSport(sport)"
            >  <!-- removed Android click effect -->


              <v-list-item-avatar
                size="32"
              >
                <v-img
                  :src="(sportsToIconsMapping[sport.sportIdentifier]?sportsToIconsMapping[sport.sportIdentifier]:sportsToIconsMapping.defaultIcon)"

                  height="32"
                  width="32"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-html="$t(`sports.${sport.sportIdentifier}`)"></v-list-item-title>
              </v-list-item-content>
              <!-- not required as per the specs but leaving the code here, just in case we need it later
              <v-list-item-action
                v-if="botMarketMakingTree[sport.id] && botMarketMakingTree[sport.id].botsActive > 0"
                :class="'bot-active-indication'">
                <v-list-item-action-text
                  v-text="botMarketMakingTree[sport.id].botsActive"></v-list-item-action-text>
              </v-list-item-action>
              -->
              <v-list-item-action
                v-if="botMarketMakingTree[sport.id] && botMarketMakingTree[sport.id].botsStopped > 0"
                :class="'bot-inactive-indication'">
                <v-list-item-action-text
                  v-text="botMarketMakingTree[sport.id].botsStopped"></v-list-item-action-text>
              </v-list-item-action>

              <v-list-item-action v-if="sport.liveNow > 0" :class="'total-indication'">
                <v-list-item-action-text v-text="sport.liveNow"></v-list-item-action-text>
              </v-list-item-action>

            </v-list-item>
            <v-divider v-if="i !== sportsList.length"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
      <CompetitionsList v-if="selectedSport !== 'none'">

      </CompetitionsList>

    </v-navigation-drawer>
    <v-dialog v-if="nonDesktopMode && selectedEvent === 'none'" v-model="isChoosingLeaguesMobile"
              scrollable width="500px"
              overlay-color="#0c1016"
              overlay-opacity="0.6"
              :persistent="true"
              :no-click-animation="true"

    >

      <v-card>
        <v-row class="" no-gutters style="display:block;">
          <!--  <v-card-title class="pa-0 select-competitions-title float-left">{{ $t('sidebar.selectCompetitions')}}</v-card-title> -->
          <v-col class="pt-2 pb-2 pr-4 pl-4 select-competitions-title">{{
            $t('sidebar.selectCompetitions')}}
          </v-col>
        </v-row>

        <v-card-text style="height: 600px;">
          <CompetitionsList v-show="selectedSport !== 'none'">

          </CompetitionsList>

        </v-card-text>

        <v-footer
          class="text-right float-right fix-footer-styling" style=""
        >
          <div class="float-right actions-group">
            <v-btn :ripple="false" depressed class="float-right kill-v-btn-css"
                   @click="setFiltersSelections">{{ $t('sidebar.select') |
              removeDiacriticsFromUppercase}}
            </v-btn>
            <v-btn :ripple="false" text class="float-right kill-v-btn-css"
                   @click="closeFiltersModalMobile">{{ $t('sidebar.cancelModal') |
              removeDiacriticsFromUppercase}}
            </v-btn>
          </div>

        </v-footer>
      </v-card>

    </v-dialog>
    <div v-show="!(sportsList.length>0) && nonDesktopMode"
         class="mobile-sport-placeholder">
      <v-img :src="mobileSportPlaceholder" v-for="i in 10" v-bind:key="i" :eager="true">

      </v-img>
    </div>

    <div
      v-if="nonDesktopMode && sportsList.length>0  && selectedEvent === 'none'"
      class="custom-slider">
      <div
        v-if="isLaptop"
        class="custom-slider-navigation custom-slider-navigation-left"
        @click="moveSportsBar('left')"
        v-bind:style="sportsBarStyleButtonLeft">
        <v-img
          :src="utilityIcons.toolbarLeft"
        >
        </v-img>
      </div>
      <div
        v-bind:class="{'custom-toolbar-wrapper': true,
          'custom-toolbar-both-gradient': gradientBackground == 'both' && isLaptop,
          'custom-toolbar-left-gradient': gradientBackground == 'left'&& isLaptop,
          'custom-toolbar-right-gradient': gradientBackground == 'right' && isLaptop}">

        <v-app-bar
          class="custom-toolbar"
          v-if="nonDesktopMode && sportsList.length>0 "
          :collapse="false"
          :collapse-on-scroll="false"
          elevation="0"
          height="auto"
          ref="scrollToolbar"
        >
          <div class="custom-toolbar-cell"
               v-bind:class="{'sport-is-selected':sportsList[0].id === selectedSportData.id || selectedSport === 'none'}"
               @click="setSelectedSport('none')">
            <!-- <v-badge

              color="#5C5F61"
              :content="sportsList[0].liveNow"
              offset-x="0"
              offset-y="0"
            > -->
            <img
              class="sports-cell-image"
              :src="sportsToIconsMapping.defaultIcon"
              height="40"
              width="40"
            ></img>

            <!-- </v-badge> -->
            <div style="margin-top: 2px">{{$t(`sports.${sportsList[0].sportIdentifier}`)}}</div>
            <div v-if="sportsList[0].liveNow > 0" class="live-badge">{{ sportsList[0].liveNow }}
            </div>
          </div>
          <div v-for="(sport, i) in sportsList" v-bind:key="sport.id" class="custom-toolbar-cell"
               @click="setSelectedSport(sport)"
               v-bind:class="{'sport-is-selected':sport.id === selectedSportData.id}"
               v-if="sportsList.length > 0 && i > 0">
            <!-- <v-badge

              color="#5C5F61"
              :content="sport.liveNow"
              offset-x="0"
              offset-y="0"
            > -->
            <img
              class="sports-cell-image"
              :src="(sportsToIconsMapping[sport.sportIdentifier]?sportsToIconsMapping[sport.sportIdentifier]:sportsToIconsMapping.defaultIcon)"
              height="40"
              width="40"
              :eager="true"
            ></img>

            <!-- </v-badge> -->
            <!--  <br>
            <div style="margin-top: -7px"> -->
            <div style="margin-top: 2px">{{$t(`sports.${sport.sportIdentifier}`)}}</div>
            <div v-if="sport.liveNow > 0" class="live-badge">{{ sport.liveNow }}</div>
          </div>

        </v-app-bar>
      </div>
      <div
        v-if="isLaptop"
        class="custom-slider-navigation custom-slider-navigation-right"
        @click="moveSportsBar('right')"
        v-bind:style="sportsBarStyleButtonRight">
        <v-img
          :src="utilityIcons.toolbarRight"
        >
        </v-img>
      </div>
    </div>
  </div>

</template>

<script>
import CompetitionsList from '@/components/CompetitionsList';
import BasketBallIcon from '../assets/Sports/Basketball.svg';
import SoccerIcon from '../assets/Sports/Soccer.svg';
import TableTennis from '../assets/Sports/Ping-Pong.svg';
import TennisIcon from '../assets/Sports/Tennis.svg';
import CricketIcon from '../assets/Sports/Cricket.svg';
import SpecialBets from '../assets/Sports/Special Bets.svg';
import ToolbarLeft from '../assets/utility/Toolbar_Left.svg';
import ToolbarRight from '../assets/utility/Toolbar_Right.svg';
import MobileSportPlaceholder from '../assets/utility/SportPlaceholderMobileSquare.svg';

//Prefetch iamges
const BasketBallIconObj = new Image();
BasketBallIconObj.src = BasketBallIcon;
const SoccerIconObj = new Image();
SoccerIconObj.src = SoccerIcon;
const TableTennisObj = new Image();
TableTennisObj.src = TableTennis;
const TennisIconObj = new Image();
TennisIconObj.src = TennisIcon;
const CricketIconObj = new Image();
CricketIconObj.src = CricketIcon;
const SpecialBetsObj = new Image();
SpecialBetsObj.src = SpecialBets;
const ToolbarLeftObj = new Image();
ToolbarLeftObj.src = ToolbarLeft;
const ToolbarRightObj = new Image();
ToolbarRightObj.src = ToolbarRight;

const MobileSportPlaceholderObj = new Image();
MobileSportPlaceholderObj.src = MobileSportPlaceholder;

console.log(SoccerIcon);
export default {
  name: 'Sidebar',
  components: {
    CompetitionsList
  },
  data() {
    return {
      drawer: true,
      mobileSportPlaceholder: MobileSportPlaceholder,
      sportsBarStyleButtonLeft: {
        display: 'none'
      },
      sportsBarStyleButtonRight: {
        display: 'none'
      },
      gradientBackground: 'none',
      utilityIcons: {
        toolbarLeft: ToolbarLeft,
        toolbarRight: ToolbarRight
      },
      sportsToIconsMapping: {
        defaultIcon: SpecialBetsObj.src,
        soccer: SoccerIconObj.src,
        tennis: TennisIconObj.src,
        basketball: BasketBallIconObj.src,
        tabletennis: TableTennisObj.src,
        cricket: CricketIconObj.src,
      },
      items: [
        {
          title: 'American Football',
          icon: 'mdi-view-dashboard',
          contentNumber: 5
        },
        {
          title: 'Basketball',
          icon: 'mdi-view-dashboard',
          contentNumber: 15
        },
        {
          title: 'Cricket',
          icon: 'mdi-view-dashboard',
          contentNumber: 25
        },
      ],
      color: 'primary',
      colors: [
        'primary',
        'blue',
        'success',
        'red',
        'teal',
      ],
      right: false,
      permanent: true,
      miniVariant: false,
      expandOnHover: false,
      background: false,
    };
  },
  computed: {
    botMarketMakingTree: function () {
      return this.$store.state.trader.bettingBot.supportedSportsMap;
    },

    selectedEvent: function (event) {
      return this.$store.state.navigations.selectedEvent;
    },
    initialStateReady: function () {
      return this.$store.state.initialStateReady;
    },
    mobileDialogPayloads: function () {
      return this.$store.state.navigations.mobileDialogPayloads;
    },
    nonDesktopMode: function () {
      return this.$store.state.deviceMode !== 'desktop';
    },
    isLaptop: function () {
      return this.$store.state.deviceMode === 'laptop';
    },
    selectedSportData: function () {
      return this.$store.state.navigations.selectedSportData;
    },
    sportsList: function () {
      return this.$store.state.navigations.sports;
    },
    selectedSport: function () {
      return this.$store.state.navigations.selectedSport;
    },
    isChoosingLeaguesMobile: function () {
      return this.$store.state.navigations.isChoosingLeaguesMobile;
    }
  },
  methods: {
    setBackgroundGradient: function (offset) {
      const scrollToolbar = this.$refs.scrollToolbar;
      if (offset <= 0) {
        this.gradientBackground = 'right';
      } else if (offset > 0 && offset < scrollToolbar.$el.scrollWidth - scrollToolbar.$el.clientWidth) {
        this.gradientBackground = 'both';
      } else {
        this.gradientBackground = 'left';
      }
    },
    moveSportsBar: function (direction) {
      const scrollToolbar = this.$refs.scrollToolbar;
      let offset;
      if (direction == 'right') {
        scrollToolbar.$el.scrollLeft += scrollToolbar.$el.clientWidth;
        offset = scrollToolbar.$el.scrollLeft + scrollToolbar.$el.clientWidth;
      } else {
        scrollToolbar.$el.scrollLeft -= scrollToolbar.$el.clientWidth;
        offset = scrollToolbar.$el.scrollLeft - scrollToolbar.$el.clientWidth;
      }
      this.sportsBarStyleButtonLeft.display = offset <= 0 ? 'none' : 'flex';
      this.sportsBarStyleButtonRight.display = offset >= scrollToolbar.$el.scrollWidth - scrollToolbar.$el.clientWidth ? 'none' : 'flex';
      this.setBackgroundGradient(offset);
    },
    resetMobileFiltersState: function () {
      this.$store.commit('resetMobileFiltersState');
    },
    setFiltersSelections: function () {
      this.$store.commit('setSelectedEvent', 'none');
      this.$store.commit('setSelectionsForFilters');
      this.$store.commit('setHasData');
      this.closeFiltersModalMobile();
    },
    setSelectedSport: function (sport) {
      this.$store.dispatch('selectSportAndResetEvent', sport);
      this.$store.commit('setSelectedCategory', 'none');
      this.$store.commit('setSelectedTournament', 'none');
      this.$store.commit('setSelectedEvent', 'none');

      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
    showFiltersModalMobile: function () {
      this.$store.commit('setIsChoosingLeaguesMobile', true);
    },
    closeFiltersModalMobile: function () {
      this.$store.commit('setIsChoosingLeaguesMobile', false);
    },
    showNavigationButtons: function () {
      const scrollToolbar = this.$refs.scrollToolbar;
      if (scrollToolbar == undefined) {
        setTimeout(this.showNavigationButtons, 500);
        return;
      }
      if (scrollToolbar.$el.scrollWidth <= scrollToolbar.$el.clientWidth) {
        this.sportsBarStyleButtonLeft.display = this.sportsBarStyleButtonRight.display = 'none';
      } else {
        this.sportsBarStyleButtonLeft.display = scrollToolbar.$el.scrollLeft == 0 ? 'none' : 'flex';
        this.sportsBarStyleButtonRight.display = scrollToolbar.$el.scrollLeft == scrollToolbar.$el.scrollWidth - scrollToolbar.$el.clientWidth ? 'none' : 'flex';
        this.setBackgroundGradient(scrollToolbar.$el.scrollLeft);
      }
    },
    selectPopularAsSport: function () {
      this.$store.dispatch('selectSportAndResetEvent', 'none');
      this.$store.commit('setTimeFilter', 'all');
      this.$store.commit('setHasData');

    },
  },
  watch: {
    isLaptop: function (isLaptop) {
      if (isLaptop) {
        this.showNavigationButtons();
      }
    },
    sportsList: function (newSportsList) {
      this.showNavigationButtons();
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
  @media screen and (max-width: 1500px) and (min-width: 1280px) {
    .custom-slider {
      width: calc(100% - 360px) !important;
    }
  }

  @media screen and (max-width: 883px) {
    .custom-toolbar-right-gradient:after {
      opacity: 0;
    }

    .custom-toolbar {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }

    .custom-slider:hover .custom-slider-navigation {
      opacity: 0 !important;
    }

    .custom-toolbar-cell:last-child {
      margin-right: 8px;
    }
  }

  @media screen and (min-width: 884px) {

    .custom-toolbar-cell:last-child {
      margin-right: 16px;
    }

  }

  .sport-is-selected {
    background: #FFFFFF !important;
    border-radius: 4px;
  }

  .sport-is-selected-desktop {
    color: #0C1016;
    font-weight: bold;
    font-size: 14px;
  }

  .v-list {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .v-divider {
    border-width: 1px 1px 0px;
  }

  .sports-sidebar-scrollbar {
    overflow-y: hidden;
    height: 100vh;
    scrollbar-width: thin;
    overscroll-behavior: contain;
  }

  .sports-sidebar-scrollbar > div,
  .sports-sidebar-scrollbar > hr {
    width: 256px;
  }

  .sports-sidebar-scrollbar:hover {
    overflow-y: auto;
  }

  .sports-sidebar-scrollbar::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
  }

  .sports-sidebar-scrollbar::-webkit-scrollbar-thumb {
    background: #c1c1c1;
  }

  .sports-sidebar-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
  }

  .v-navigation-drawer {
    min-height: 100%;
    position: fixed;
  }

  .theme--light.v-navigation-drawer .v-divider {
    border-color: #F4F5F7;

  }

  .v-list-item__action.total-indication {
    display: flex;
    flex-direction: column;
    padding: 2px 4px;
    margin-left: 8px !important;
    height: 18px;
    top: calc(50% - 18px / 2);
    color: #5c5f61;
    /* 200 */
    background: #F4F5F7;
    border-radius: 16px;
  }

  .v-list-item__action.bot-active-indication {
    display: flex;
    flex-direction: column;
    padding: 2px 4px;
    margin-left: 8px !important;
    height: 18px;
    top: calc(50% - 18px / 2);
    color: #F4F5F7 !important;
    /* 200 */
    background: var(--primary);
    border-radius: 16px;
  }

  .v-list-item__action.bot-active-indication > .v-list-item__action-text {
    display: flex;
    color: #F4F5F7 !important;
  }

  .v-list-item__action.bot-inactive-indication {
    display: flex;
    flex-direction: column;
    padding: 2px 4px;
    margin-left: 8px !important;
    height: 18px;
    top: calc(50% - 18px / 2);
    color: #F4F5F7 !important;
    background: var(--cyborg);

    /* 200 */
    border-radius: 16px;
  }

  .v-list-item__action.bot-inactive-indication > .v-list-item__action-text {
    color: #F4F5F7 !important;
  }

  .v-list-item__action {
    display: flex;
    flex-direction: column;
    padding: 2px 5px;

    height: 18px;
    top: calc(50% - 18px / 2);
    min-width: 20px;
    /* 200 */

    background: #F4F5F7;
    border-radius: 16px;
    margin-right: 0px; /* margin converted to list item right padding */
    margin-top: 8px; /* as per the specs */
    margin-bottom: 8px; /* as per the specs */
  }

  .v-list-item {
    padding-left: 8px !important; /* from previous 8px margin of the avatar */
    /* margin-left: 8px; */ /* put the margin on the left of the avatar */
    padding-right: 16px;
    min-height: 0px;
  }

  .v-list-item__action-text {
    position: static;
    left: 22.73%;
    right: 22.73%;
    top: 11.11%;
    bottom: 11.11%;

    /* 9 XXS / Bold */

    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;

    /* 600 */

    color: #5C5F61;

    /* Inside Auto Layout */

    flex: none;
    order: 0;
    align-self: center;
    margin: 0px 0px;
  }

  .custom-slider {
    display: flex;
    flex-direction: row;
    /*justify-content: space-evenly;*/
    align-items: center;
    padding-top: 8px !important;
    padding-bottom: 16px !important;
    position: relative;
  }

  .custom-slider:hover .custom-slider-navigation {
    opacity: 1;
  }

  .custom-slider-navigation {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    z-index: 5;
  }

  .custom-slider-navigation > .v-image {
    width: 32px;
    height: 32px;
    z-index: 5;
    cursor: pointer;
  }

  .custom-slider-navigation-right {
    right: 0;
  }

  .custom-slider-navigation-left {
    margin-left: 16px;
  }

  .custom-slider-navigation-right {
    margin-right: 16px;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .custom-toolbar-wrapper {
    padding-left: 0px !important;
    /* the padding is enough - margin-top: 4px!important; */
    display: flex;
    white-space: nowrap;
    padding-right: 0px !important;
    width: 100%;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    text-align: center;
    position: relative;
    /*justify-content: center;*/
    transition: all 0.6s ease-in-out;
  }

  .custom-toolbar-wrapper::after {
    content: "";
    position: absolute;
    z-index: 1;
    pointer-events: none;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
  }

  .custom-toolbar-right-gradient::after {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) calc(100% - 61px), rgba(244, 245, 247, 1) calc(100% - 16px)) !important;
  }

  .custom-toolbar-both-gradient::after {
    background-image: linear-gradient(90deg, rgba(244, 245, 247, 1) 16px, rgba(255, 255, 255, 0) 61px, rgba(255, 255, 255, 0) calc(100% - 61px), rgba(244, 245, 247, 1) calc(100% - 16px)) !important;
  }

  .custom-toolbar-left-gradient::after {
    background-image: linear-gradient(90deg, rgba(244, 245, 247, 1) 16px, rgba(244, 245, 247, 0) 61px) !important;
  }

  .custom-toolbar {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    overflow-x: scroll;
    scrollbar-width: none;
    display: flex !important;
    flex: 0 0 auto !important;
    scroll-behavior: smooth;
  }

  .custom-toolbar-wrapper::-webkit-scrollbar {
    display: none;
  }

  /*  .custom-toolbar-cell:first-child{
      margin-left:8px;
    }*/
  .custom-toolbar-cell {
    /* Auto Layout */

    cursor: pointer;
    display: flex;
    flex-direction: column;
    /*padding: 2px 8px;*/
    /* not needed, right margin set to 8px - margin-left: 4px; */
    margin-right: 8px;
    padding: 2px 8px;
    /*width: 68px!important;*/
    height: 65px;
    /*width: 68px;*/
    /*flex-basis: 80px;*/
    /* irrelevant
    left: 8px;
    top: 96px; */
    text-overflow: ellipsis;
    /* 200 */
    white-space: nowrap;

    background: transparent;
    border-radius: 4px;

    font-size: 14px;
    line-height: 19px;
    position: relative;
    top: 0px;
    align-items: center;
  }


  .custom-toolbar-navigation-button {
    height: 32px;
    width: 32px;
    background: #ffffff;
    position: absolute;
    right: 20px;
    z-index: 100;
  }

  .live-badge {
    position: absolute;
    right: 4px;
    top: 4px;
    font-weight: bold;
    font-size: 10px;
    line-height: 14px;
    color: #5c5f61;
  }

  >>> .v-toolbar__content {
    width: min-content;
    padding: 0px;
  }

  .v-dialog > .v-card > .v-card__text {
    padding: 0;
  }

  >>> .v-dialog {
    margin: 8px;
  }

  .v-footer {
    display: block;
    padding: 0px;
  }

  >>> .actions-group .v-btn.kill-v-btn-css {
    letter-spacing: unset;
    text-indent: 0;
    font-weight: bold;
    font-size: 12px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 0px;
    margin-left: 4px;
  }

  >>> .actions-group .v-btn.kill-v-btn-css.v-btn--depressed {
    background-color: #17a3f2;
  }

  >>> .actions-group .v-btn.kill-v-btn-css.v-btn--depressed:hover {
    background-color: #1389CB;
  }

  >>> .actions-group .kill-v-btn-css.theme--light.v-btn:focus::before,
  >>> .actions-group .kill-v-btn-css.theme--light.v-btn:hover::before {
    opacity: 0;
  }

  >>> .actions-group .v-btn.kill-v-btn-css .v-btn__content {
    line-height: 16px;
  }

  >>> .actions-group .kill-v-btn-css.v-btn:not(.v-btn--round).v-size--default {
    height: min-content;
  }

  >>> .actions-group .v-btn.kill-v-btn-css.v-btn--flat .v-btn__content {
    color: #a0a3a5;
  }

  >>> .actions-group .v-btn.kill-v-btn-css.v-btn--flat:hover .v-btn__content {
    color: #727779;
  }

  >>> .actions-group .v-btn.kill-v-btn-css.v-btn--depressed .v-btn__content {
    color: white;
  }

  .v-btn {
    margin: 8px;
  }

  >>> .v-badge__badge {
    background-color: transparent !important;
    color: #5C5F61;
  }

  .theme--light.v-app-bar.v-toolbar.v-sheet {
    background: transparent;
  }

  .sports-cell-image {
    /*margin-right: 11px;*/
    /*margin-left: 11px;*/
  }

  >>> .v-badge__badge {
    top: -1px !important;
    font-weight: bold;
    font-size: 10px;
  }

  >>> .v-list-item__title {
    font-size: 14px;
    color: #0C1016;
    /*opacity: 0.84;*/
    line-height: 18px; /* added as per designer's instructions, just in cases a translated text wraps */
    white-space: normal; /* added to support wrapping text */
  }

  .v-application--is-ltr .v-list-item__avatar:first-child {
    margin-right: 8px;
    margin-left: 0px; /* added last 3 margins as per the specs - 8px left margin became left padding of list item */
    margin-top: 4px;
    margin-bottom: 4px
  }

  .v-list-item__content {
    padding: 0px;
    margin-top: 8px; /* added as per the specs */
    margin-bottom: 8px; /* added as per the specs */
  }

  /* disable default highlight */
  .theme--light.v-list-item:hover::before,
  .theme--light.v-list-item:focus::before {
    opacity: 0;
  }

  /* disable default highlight of active item AND focus highlight */
  >>> .theme--light.v-list-item--active.v-list-item--link:hover::before,
  >>> .theme--light.v-list-item--active.v-list-item--link::before,
  >>> .theme--light.v-list-item--active.v-list-item--link:focus::before {
    opacity: 0;
  }

  /* implement highlight 100 */
  .v-list-item:hover {
    background-color: #fafafa;
  }

  >>> .v-list-item:hover {
    background-color: #fafafa;
  }

  .select-competitions-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 33px;
    letter-spacing: unset;
    color: var(--grey-900) !important;
  }

  .v-footer.text-right.float-right.v-sheet.theme--light.fix-footer-styling {
    background-color: white;
    box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1);
    padding: 8px;
  }

  .mobile-sport-placeholder {
    display: flex;
    flex-direction: row;
    padding: 0 8px;
    margin-top: 8px;
    margin-bottom: 16px;
    min-height: 65px;

  }

  .mobile-sport-placeholder > .v-image::after {
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .3), hsla(0, 0%, 100%, 0));
    -webkit-animation: loading 1.5s infinite;
    animation: loading 1.5s infinite;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }

  .mobile-sport-placeholder >>> .v-responsive {
    flex: 0 0 auto;
  }

  .mobile-sport-placeholder > .v-image {
    margin-right: 8px;
  }

  @-webkit-keyframes loading {
    to {
      transform: translateX(100%)
    }
  }

  @keyframes loading {
    to {
      transform: translateX(100%)
    }
  }

</style>
